import { useLocation } from 'react-router';

import { useHasFeature } from '@bai/features';

import UniversalHeader from '../assets/universal-header/UniversalHeader';

export default function AppHeader() {
  const location = useLocation();
  const isRoot = location.pathname === '/' || location.pathname === '';
  const isUniversalHeaderEnabled = useHasFeature('enableUniversalHeader');

  if (!isRoot && isUniversalHeaderEnabled) {
    return <UniversalHeader />;
  }
  return null;
}
